/*
 * SPDX-FileCopyrightText: 2022 CERN.
 * SPDX-License-Identifier: MIT
 */

export { default as AdminDetailsView } from "./AdminDetailsView";
export { default as DetailsComponent } from "./DetailsComponent";
